import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { OffertVerificationDialogComponent } from '../components/offert/offert-verification-dialog/offert-verification-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OffertVerificationDialogService {

  loadOffert$ = new Subject();

  constructor(private dialog: MatDialog) { }

  public openDialog(privatperson: boolean) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '50%';
    dialogConfig.height = '50%';

    dialogConfig.data = {
      privatperson: privatperson
    };

    const dialogRef = this.dialog.open(OffertVerificationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadOffert$.next(result);
      }
    });
  }
}
